import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

@Injectable()
export class DocumentoService extends EntityService<any> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'documento',
        urlBackend: configService.backendURL
      }
    );
  }

  /**
   * Download do documento assinado ou não
   * @param documento_id
   * @param assing
   * @returns
   */
  downloadDocumento(documento_id: string): Observable<any> {
    const url = `${this.baseURL}/${documento_id}`;
    return this.http.get(url, {
      headers: this.getHeader(),
      responseType: 'blob'
    });
  }
}
